import { observer } from 'mobx-react';
import * as React from 'react';
import * as classNames from 'classnames';
import { IItemInventory, EInventoryStatus } from '../../../../../common/interfaces/search';
import { IStockDetailsView } from '../../../../../common/interfaces/stock';
import { LoadingSpinner } from '../../../components/indicator';
import { Tooltip } from '../../../components/popup';

// Styles
const s = require('./PortalSearchItem.css');
const stockInformation = require('./../../../assets/information-icon.svg');
const stockLargerOrEqualIcon = require('./../../../assets/larger-or-equal-sign.svg');
const stockLargerThanIcon = require('./../../../assets/larger-than-sign.svg');
const stockSmallerThanIcon = require('./../../../assets/smaller-than-sign.svg');
const stockSmallerOrEqualIcon = require('./../../../assets/smaller-or-equal-sign.svg');
const stockUnavailableIcon = require('./../../../assets/cross-orange-sign.svg');

// Props
interface IPortalSearchItemInventoryPbiProps {
    onCaliforniaStockDetailsShow: () => void;
    onCaliforniaStockDetailsHide: () => void;
    californiaStockDetails: IStockDetailsView | null;
    inventory: IItemInventory[];
    itemcode: string;
    customerIsPBIPlus: boolean;
}

// Component
@observer
export class PortalSearchItemInventoryPbi extends React.Component<IPortalSearchItemInventoryPbiProps, {}> {
    static get defaultProps(): IPortalSearchItemInventoryPbiProps {
        return {
            onCaliforniaStockDetailsShow: null,
            onCaliforniaStockDetailsHide: null,
            californiaStockDetails: null,
            inventory: [],
            itemcode: '',
            customerIsPBIPlus: false
        };
    }

    public render() {
        return (
            <div className={s.inventory}>
                {this.props.inventory.map((stock) => {
                    return (
                        <div key={stock.code} className={s.stock}>
                            <p className={s.stockCode}>{stock.code}</p>

                            {stock.status !== EInventoryStatus.JustCount &&
                                stock.status !== EInventoryStatus.Unavailable &&
                                stock.code === 'CA' && (
                                    <button
                                        onClick={this.handleCaliforniaStockDetailsClick}
                                        className={s.stockDetails}
                                        title="Details"
                                    >
                                        <img src={stockInformation} alt="" />
                                    </button>
                                )}

                            <p className={s.stockCount}>
                                {stock.status !== EInventoryStatus.JustCount && (
                                    <img
                                        className={classNames(s.stockIcon, {
                                            [s.stockUnavailableIcon]: stock.status === EInventoryStatus.Unavailable
                                        })}
                                        title={
                                            stock.count !== null && typeof stock.count === 'string' ? stock.count : undefined
                                        }
                                        src={
                                            stock.status === EInventoryStatus.Unavailable
                                                ? stockUnavailableIcon
                                                : stock.status === EInventoryStatus.LargerOrEqual
                                                ? stockLargerOrEqualIcon
                                                : stockSmallerThanIcon
                                        }
                                        alt=""
                                    />
                                )}

                                {stock.status !== EInventoryStatus.Unavailable && <strong>{stock.count}</strong>}
                            </p>
                        </div>
                    );
                })}

                <Tooltip
                    className={s.stockDetailsTooltip}
                    onClose={this.handleCaliforniaStockDetailsHide}
                    title={`CA stock for item ${this.props.itemcode}`}
                    show={this.props.californiaStockDetails !== null}
                >
                    {this.props.californiaStockDetails !== null && (
                        <div className={s.stockDetailsTooltipContent}>
                            {(this.props.californiaStockDetails.loading === true && (
                                <div className={s.loading}>
                                    <LoadingSpinner active={true} size={24} />
                                    <p>Getting stock details...</p>
                                </div>
                            )) || (
                                <table className={s.stockDetailsTooltipTable}>
                                    <thead>
                                        <tr>
                                            <td>Location</td>
                                            <td />
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.props.californiaStockDetails.warehouses.map((warehouse) => {
                                            const showLessThanOrMoreThan =
                                                warehouse.onHand && warehouse.onHand > 1 ? true : false;

                                            return (
                                                <tr key={warehouse.whsCode}>
                                                    <td>{warehouse.whsName}</td>

                                                    <td
                                                        className={classNames({
                                                            [s.available]: warehouse.available
                                                        })}
                                                    >
                                                        {(this.props.customerIsPBIPlus && (
                                                            <p>{warehouse.available ? 'In stock' : 'Out of stock'}</p>
                                                        )) || (
                                                            <p>
                                                                {showLessThanOrMoreThan && (
                                                                    <img
                                                                        className={s.stockIcon}
                                                                        src={
                                                                            warehouse.onHand > 5
                                                                                ? stockLargerThanIcon
                                                                                : stockSmallerOrEqualIcon
                                                                        }
                                                                        alt=""
                                                                    />
                                                                )}

                                                                <strong>
                                                                    {!warehouse.onHand
                                                                        ? '0'
                                                                        : warehouse.onHand === 1
                                                                        ? '1'
                                                                        : '5'}
                                                                </strong>
                                                            </p>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}
                </Tooltip>
            </div>
        );
    }

    private handleCaliforniaStockDetailsClick = () => {
        this.props.onCaliforniaStockDetailsShow();
    };

    private handleCaliforniaStockDetailsHide = () => {
        this.props.onCaliforniaStockDetailsHide();
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalSearch/PortalSearchItemInventoryPbi.tsx